import { gql } from '__generated__';

export default gql(`
  query GetProductStats($id: ID!, $tickets: [ID!]) {
    product(id: $id) {
      id
      promotions {
        id
        title
        sold_count(tickets: $tickets)
        revenue(tickets: $tickets)
        remaining_amount(tickets: $tickets)
        capacity
        active
      }
      product_variants {
        id
        title
        sold_count(tickets: $tickets)
        revenue(tickets: $tickets)
        remaining_amount(tickets: $tickets)
        capacity
      }
    }
  }
`);
